import { useEffect } from "react";

import "./App.css";

import AppRoute from "./route";
import { ThemeProvider } from "styled-components";
import ErrorBoundary from "./components/global/ErrorBoundary";

import { GlobalStyle } from "./styles/global.styles";

import { useLocation } from "react-router-dom";

import {
  colors,
  font,
  radii,
  shadow,
  transition,
  layout,
} from "./styles/variables";

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const theme = {
    colors,
    font,
    radii,
    shadow,
    transition,
    layout,
  };

  return (
    <div className="App">
      <ErrorBoundary>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <AppRoute />
        </ThemeProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
